import { FlaskConical, Trash2, Wrench } from "lucide-react";
import { toast } from "sonner";

import { api } from "@/api";
import { useAuth } from "@/auth";
import { DemoSessionButtons } from "@/components/cockpit/DebriefBanner";
import { errText } from "@/components/pipeline/utils";

// Paramètres › Outils admin : données de démonstration du Cockpit (administrateur uniquement)
export const AdminToolsSection = () => {
  const { user } = useAuth();
  if (user?.role !== "admin") return null;
  const demo = (del) => (del && !window.confirm("Supprimer toutes les activités de démo ?") ? Promise.resolve() : (del ? api.delete("/activities/demo") : api.post("/activities/demo"))
    .then(({ data }) => toast.success(del ? `${data.deleted} activités de démo supprimées.` : `${data.created} activités de démo créées.`))
    .catch((e) => toast.error(errText(e))));
  return (
    <section className="settings-section card admin-tools" data-testid="admin-tools-section">
      <div className="section-title"><Wrench size={20} /><div><p className="eyebrow">ADMINISTRATEUR</p><h2>Outils admin</h2></div></div>
      <p className="page-subtitle">Données de démonstration du Cockpit, pour présenter ou tester sans toucher aux vraies fiches.</p>
      <div className="button-row ck-demo">
        <DemoSessionButtons />
        <button type="button" onClick={() => demo(false)} data-testid="ck-demo-create"><FlaskConical size={14} /> Créer des démos</button>
        <button type="button" onClick={() => demo(true)} data-testid="ck-demo-delete"><Trash2 size={14} /> Supprimer les démos</button>
      </div>
    </section>
  );
};
